// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { CveRetestJobStatusSchema } from '../inputTypeSchemas/CveRetestJobStatusSchema'

/////////////////////////////////////////
// CVE RETEST JOB SCHEMA
/////////////////////////////////////////

export const CveRetestJobSchema = z.object({
  status: CveRetestJobStatusSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  scanType: z.string(),
  scanId: z.string().nullable(),
  cveIds: z.string().array(),
  matchedSoftware: JsonValueSchema.nullable(),
  matchedHostCount: z.number().int(),
  smokeTestTriggered: z.boolean(),
  errorMessage: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type CveRetestJob = z.infer<typeof CveRetestJobSchema>

export default CveRetestJobSchema;
